module.exports = __webpack_public_path__ + "img/album14_33.cbbbf812.jpg";